"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.controlItems = exports.Variation_A_Items = void 0;
var controlItems = [{
  imgAltText: '',
  errorMessage: null,
  text: 'Certified Reference Materials: CRMs for forensic, clinical, environmental, pharmaceutical, and food & beverage testing.',
  untransformedUrl: '/products/analytical-chemistry/reference-materials/certified-reference-materials',
  url: '/products/analytical-chemistry/reference-materials/certified-reference-materials',
  title: 'Certified Reference Materials',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/certified-reference-materials.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Complete membrane filtration systems for accurate results in bioburden testing. Rapid microbial testing technologies can speed up your time-to-result.',
  untransformedUrl: '/products/industrial-microbiology/microbial-filtration',
  url: '/products/industrial-microbiology/microbial-filtration',
  title: 'Microbial Filtration',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/microbial-filtration.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Your Solvent Source: Find the right fit with Supelco<sup>®</sup>, SigmaAldrich<sup>®</sup>, & SAFC<sup>®</sup> brands, covering analytical, lab, & biopharmaceutical uses. Order online.',
  untransformedUrl: '/products/analytical-chemistry/analytical-chromatography/solvents',
  url: '/products/analytical-chemistry/analytical-chromatography/solvents',
  title: 'Solvents',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/solvents.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'A microbial culture medium promotes and supports the growth and the survival of microorganisms. It can be prepared as a liquid broth, solid agar plate or as semi-solid deeps. We offer a broad range of dehydrated and ready-to-use culture media that fulfils the highest industry standards and regulatory requirements.',
  untransformedUrl: '/products/industrial-microbiology/microbial-culture-media',
  url: '/products/industrial-microbiology/microbial-culture-media',
  title: 'Microbial Culture Media',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/microbial-culture-media.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Explore our complete line of popular density gradient media for the separation or extraction of leukocytes, viruses, DNA, RNA, organelles and other research and clinical applications.',
  untransformedUrl: '/products/clinical-diagnostics/tissue-diagnostics/cell-separation-media',
  url: '/products/clinical-diagnostics/tissue-diagnostics/cell-separation-media',
  title: 'Cell Separation Media for Research, Diagnostic & Pharmaceutical Applications',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/cell-separation-media.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Choose Millex<sup>®</sup> syringe filters: sterile, nonsterile formats. Wide membrane, housing options for HPLC, UHPLC, dissolution testing compatibility.',
  untransformedUrl: '/products/filtration/laboratory-syringe-filters/millex-syringe-filters',
  url: '/products/filtration/laboratory-syringe-filters/millex-syringe-filters',
  title: 'Millex<sup>®</sup> Syringe Filters',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/millex-syringe-filters.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'We offer a complete selection of Aldrich<sup>®</sup> chemistry glassware including a full range of standard beakers, flasks, tubing, reaction vessels, and chromatography columns as well as custom glassblowing services.',
  untransformedUrl: '/products/labware/glassware',
  url: '/products/labware/glassware',
  title: 'Glassware',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/glassware.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Pathogen testing is a key component and critical success factor in effective food safety and process control programs. Explore our wide range of pathogen screening products that suit your needs.',
  untransformedUrl: '/products/industrial-microbiology/pathogen-screening-kits-instuments-and-disposables',
  url: '/products/industrial-microbiology/pathogen-screening-kits-instuments-and-disposables',
  title: 'Pathogen Screening Kits, Instruments & Disposables',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/pathogen-screening-kits.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Centrifugal and pressurized ultrafiltration devices for protein concentration, desalting, buffer exchange, separation, and diafiltration of biological and environmental samples in preparation for downstream applications.',
  untransformedUrl: '/products/protein-biology/protein-sample-prep/amicon-centrifugals',
  url: '/products/protein-biology/protein-sample-prep/amicon-centrifugals',
  title: 'Amicon<sup>®</sup> Centrifugals',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/amicon-centrifugals.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Millipore<sup>®</sup> membranes serve diverse sectors with products like mixed cellulose esters and PVDF.',
  untransformedUrl: '/products/filtration/laboratory-filter-membranes/millipore-filter-membranes',
  url: '/products/filtration/laboratory-filter-membranes/millipore-filter-membranes',
  title: 'Millipore<sup>®</sup> Filter Membranes',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/millipore-filter-membranes.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Genuine Milli-Q<sup>®</sup> consumables support long water purification system lifetime & ensure consistent lab water quality—from pretreatment, purification and polishing to storage and distribution.',
  untransformedUrl: '/products/water-purification/milli-q-consumables',
  url: '/products/water-purification/milli-q-consumables',
  title: 'Milli-Q<sup>®</sup> Lab Water Purification Consumables',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/milli-q-consumables.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Greener Alternative Products promote sustainability in chemistry, aligning with Green Chemistry Principles and Design for Sustainability.',
  untransformedUrl: '/products/chemistry-and-biochemicals/greener-alternative-products',
  url: '/products/chemistry-and-biochemicals/greener-alternative-products',
  title: 'Greener Alternative Products',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/greener-alternative-products.svg',
  externalUrl: false
}];
exports.controlItems = controlItems;
var Variation_A_Items = [{
  imgAltText: '',
  errorMessage: null,
  text: 'Custom DNA oligos comply with ISO quality systems for research and commercial applications.',
  untransformedUrl: '/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes',
  url: '/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes',
  title: 'Custom DNA Oligos & qPCR Probes',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/oligos.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Complete membrane filtration systems for accurate results in bioburden testing. Rapid microbial testing technologies can speed up your time-to-result.',
  untransformedUrl: '/products/industrial-microbiology/microbial-filtration',
  url: '/products/industrial-microbiology/microbial-filtration',
  title: 'Microbial Filtration',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/microbial-filtration.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Certified Reference Materials: CRMs for forensic, clinical, environmental, pharmaceutical, and food & beverage testing.',
  untransformedUrl: '/products/analytical-chemistry/reference-materials/certified-reference-materials',
  url: '/products/analytical-chemistry/reference-materials/certified-reference-materials',
  title: 'Certified Reference Materials',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/certified-reference-materials.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Discover advanced environmental monitoring and aseptic process simulation solutions for pharmaceutical manufacturing. Ensure GMP compliance with our specialized tools and media for cleanrooms, isolators, and RABS.',
  untransformedUrl: '/products/industrial-microbiology/viable-air-samplers',
  url: '/products/industrial-microbiology/viable-air-samplers',
  title: 'Environmental Monitoring and Aseptic Process Simulation',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/viable-air-samplers.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Organoids are in vitro models that closely replicate the complex physiology of native tissues while also being accessible, reproducible, and scalable like traditional culture methods. Choose colon organoids, lung organoid culture systems, and patient-derived organoids from our biobank.',
  untransformedUrl: '/products/cell-culture-and-analysis/3d-cell-culture/organoids',
  url: '/products/cell-culture-and-analysis/3d-cell-culture/organoids',
  title: 'Organoids',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/organoids.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Your Solvent Source: Find the right fit with Supelco<sup>®</sup>, SigmaAldrich<sup>®</sup>, & SAFC<sup>®</sup> brands, covering analytical, lab, & biopharmaceutical uses. Order online.',
  untransformedUrl: '/products/analytical-chemistry/analytical-chromatography/solvents',
  url: '/products/analytical-chemistry/analytical-chromatography/solvents',
  title: 'Solvents',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/solvents.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Explore our complete line of popular density gradient media for the separation or extraction of leukocytes, viruses, DNA, RNA, organelles and other research and clinical applications.',
  untransformedUrl: '/products/clinical-diagnostics/tissue-diagnostics/cell-separation-media',
  url: '/products/clinical-diagnostics/tissue-diagnostics/cell-separation-media',
  title: 'Cell Separation Media for Research, Diagnostic & Pharmaceutical Applications',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/cell-separation-media.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Discover our collection of validated human primary cells from PromoCell<sup>®</sup> human primary cells, primary blood and immune cells from BioIVT, and more.',
  untransformedUrl: '/products/cell-culture-and-analysis/cell-lines-and-specialty-cell-culture/primary-cells',
  url: '/products/cell-culture-and-analysis/cell-lines-and-specialty-cell-culture/primary-cells',
  title: 'Primary Cell Culture',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/primary-cells.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'A microbial culture medium promotes and supports the growth and the survival of microorganisms. It can be prepared as a liquid broth, solid agar plate or as semi-solid deeps. We offer a broad range of dehydrated and ready-to-use culture media that fulfils the highest industry standards and regulatory requirements.',
  untransformedUrl: '/products/industrial-microbiology/microbial-culture-media',
  url: '/products/industrial-microbiology/microbial-culture-media',
  title: 'Microbial Culture Media',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/microbial-culture-media.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'The Mobius<sup>®</sup> Bioreactor family offers single-use bioreactors for cell culturing from early development to commercial production, supporting various scales.',
  untransformedUrl: '/products/pharma-and-biopharma-manufacturing/bioprocessing-cell-culture/single-use-bioreactors',
  url: '/products/pharma-and-biopharma-manufacturing/bioprocessing-cell-culture/single-use-bioreactors',
  title: 'Bioprocessing Mobius<sup>®</sup> Single-Use Bioreactors',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/single-use-bioreactors.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Explore our electrosynthesis portfolio offering a wide range of cells and electrodes giving access to a green chemistry alternative and the multiple benefits of electrochemistry.',
  untransformedUrl: '/products/chemistry-and-biochemicals/synthesis-enabling-tools/electrosynthesis-platform',
  url: '/products/chemistry-and-biochemicals/synthesis-enabling-tools/electrosynthesis-platform',
  title: 'Electrosynthesis',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/electrosynthesis-platform.svg',
  externalUrl: false
}, {
  imgAltText: '',
  errorMessage: null,
  text: 'Choose Millex<sup>®</sup> syringe filters: sterile, nonsterile formats. Wide membrane, housing options for HPLC, UHPLC, dissolution testing compatibility.',
  untransformedUrl: '/products/filtration/laboratory-syringe-filters/millex-syringe-filters',
  url: '/products/filtration/laboratory-syringe-filters/millex-syringe-filters',
  title: 'Millex<sup>®</sup> Syringe Filters',
  thumbnail: '/deepweb/assets/sigmaaldrich/marketing/global/images/home/category/pictograms/millex-syringe-filters.svg',
  externalUrl: false
}];
exports.Variation_A_Items = Variation_A_Items;